import { ROUTES } from '~shared/config/routes';

import { hasAllowedRole, isManager, isStoreManager } from './role-checks';

import { UserInfo } from '../model';

export const getDefaultRouteByRole = (userInfo: UserInfo) => {
  if (!userInfo.employeeRole) {
    return ROUTES.partner.root;
  }

  if (isManager(userInfo) || isStoreManager(userInfo)) {
    return ROUTES.dashboard;
  }

  if (!hasAllowedRole(userInfo)) {
    return ROUTES.accessDenied;
  }

  return ROUTES.root;
};
